module.exports = __webpack_public_path__ + "img/地图英文@2x.87f69c0a.png";